<template>
  <div>
    <div class="top_bar">
      <div class="top_bar_inp">
        <img
          class="top_bar_inp_img1"
          src="../../assets/ym/logo@2x.png"
          alt=""
        />
        <input type="text" class="top_bar_inp_inp" v-model="wenzi" />
        <div class="top_bar_inp_lebal">HOT</div>
      </div>
      <el-popover placement="bottom" trigger="click">
        <div class="top_bar_item" slot="reference">
          <img
            class="top_bar_item_img"
            src="../../assets/ym/lxkf@2x.png"
            alt=""
          />
          <div class="top_bar_item_tit">联系客服</div>
        </div>

        <div
          class="top_bar_item_lxbox vue_flex vue_flex_around vue_align_center"
        >
          <div class="top_bar_item_lxbox_boxs vue_flex vue_column">
            <p class="vue-font-PingFang-bold color_35">手机扫码</p>
            <div class="vue_flex vue_flex_around vue_align_center">
              <img src="../../assets/ym/wxcode.jpg" alt="" />
            </div>
          </div>
          <div class="top_bar_item_lxbox_boxs vue_flex vue_column">
            <p class="vue-font-PingFang-bold color_35">公众号</p>
            <div class="vue_flex vue_flex_around vue_align_center">
              <img src="../../assets/ym/wxcode.jpg" alt="" />
            </div>
          </div>
        </div>
      </el-popover>
      <div class="top_bar_item">
        <img
          class="top_bar_item_img"
          src="../../assets/ym/bzzx@2x.png"
          alt=""
        />
        <div class="top_bar_item_tit">帮助中心</div>
      </div>
      <el-popover placement="bottom" trigger="click">
        <img
          slot="reference"
          class="top_bar_head"
          src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimage109.360doc.com%2FDownloadImg%2F2025%2F04%2F0321%2F296122601_4_20250403090445718&refer=http%3A%2F%2Fimage109.360doc.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1762936039&t=d3e3ac4fe0090dbc24fe8429037b4072"
          alt=""
        />

        <div class="edit_box">
          <div class="edit_box_head" @click="dialogimportVisible = true">
            <div class="edit_head_box">
              <img
                class="edit_head_box_h"
                src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimage109.360doc.com%2FDownloadImg%2F2025%2F04%2F0321%2F296122601_4_20250403090445718&refer=http%3A%2F%2Fimage109.360doc.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1762936039&t=d3e3ac4fe0090dbc24fe8429037b4072"
                alt=""
              />
              <div class="edit_head_box_t">{{ zhanghao }}</div>
            </div>
            <img
              class="edit_head_box_r"
              src="../../assets/yimou/arrright.png"
              alt=""
            />
          </div>
          <div class="edit_box_item" @click="phonedialogimportVisible = true">
            <div class="edit_box_item_l">
              <img
                src="../../assets/yimou/sjh@2x.png"
                class="edit_box_item_licon"
                alt=""
              />
              <div class="edit_box_item_lt">换手机号</div>
            </div>
            <img
              class="edit_box_item_lr"
              src="../../assets/yimou/arrright.png"
              alt=""
            />
          </div>
          <div class="edit_box_item" @click="togoout">
            <div class="edit_box_item_l">
              <img
                src="../../assets/yimou/tc@2x.png"
                class="edit_box_item_licon"
                alt=""
              />
              <div class="edit_box_item_lt red">退出登录</div>
            </div>
          </div>
          <div class="edit_box_banben">版本 {{ version }}</div>
        </div>
      </el-popover>
    </div>

    <el-dialog
      :visible.sync="dialogimportVisible"
      custom-class="unique-dialog"
      width="449px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="import-mask vue_flex vue_align_center vue_column">
        <div
          class="import-mask-title vue-font-PingFang-500 color_255 vue_relative"
        >
          修改基础信息
          <img
            src="../../assets/yimou/gb.png"
            alt=""
            class="vue_absolute h"
            @click="dialogimportVisible = false"
          />
        </div>

        <div class="mask_head_box">
          <img class="mask_head" :src="headimgurl" alt="" />
          <div class="mask_head_t">修改</div>
        </div>

        <div class="mask_name">{{ zhanghao }}</div>
        <div class="mask_cont">
          <div class="mask_cont_lebal">昵称</div>
          <input
            class="mask_cont_inp"
            type="text"
            v-model="nickname"
            placeholder="请输入昵称"
          />
        </div>
        <div class="mask_cont">
          <div class="mask_cont_lebal">密码</div>
          <div class="mask_cont_right">
            <input
              class="mask_cont_inp"
              type="text"
              v-model="psd"
              placeholder="请输入密码"
            />
            <div class="mask_cont_right_txt" @click="editpsd">修改</div>
          </div>
        </div>
        <div class="mask_btn" @click="editUserinfo">确认</div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="phonedialogimportVisible"
      custom-class="unique-dialog"
      width="449px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="import-mask vue_flex vue_align_center vue_column">
        <div
          class="import-mask-title vue-font-PingFang-500 color_255 vue_relative"
        >
          换绑手机号
          <img
            src="../../assets/yimou/gb.png"
            alt=""
            class="vue_absolute h"
            @click="phonedialogimportVisible = false"
          />
        </div>

        <div class="mask_cont mar20">
          <div class="mask_cont_lebal">原手机号</div>
          <input
            class="mask_cont_inp"
            type="text"
            v-model="oldphone"
            placeholder="请输入原手机号"
          />
        </div>

        <div class="mask_cont">
          <div class="mask_cont_lebal">新手机号</div>
          <input
            class="mask_cont_inp"
            type="text"
            v-model="newphone"
            placeholder="请输入新手机号"
          />
        </div>
        <div class="mask_btn" @click="editPhone">确认</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import DonMessage from "@/utils/message";
export default {
  data() {
    return {
      wenzi: "5大平台数据自动接入 了解详情 >",
      editflg: false,
      dialogimportVisible: false,
      phonedialogimportVisible: false,
      zhanghao: "12312",
      psd: "",
      oldphone: "",
      newphone: "",
      nickname: "",
      headimgurl: "",
      password: "",
      version: "",
    };
  },
  created() {
    this.getUser();
    this.version = this.trimQuotes(Cookies.get("ymversion"));
  },
  methods: {
    async editUserinfo() {
      if (!this.nickname) return DonMessage.error(`请输入昵称`);
      if (!this.headimgurl) return DonMessage.error(`请选择头像`);
      const res = await this.$http.get(this.$urls.changeuser, {
        nickname: this.nickname,
        headimgurl: this.headimgurl,
      });
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      DonMessage.success("修改成功");
      this.getUser();
      this.dialogimportVisible = false;
    },
    togoout() {
      this.$alert("是否确定要退出登录", "提示", {
        confirmButtonText: "确定",
        callback: (action) => {
          Cookies.remove("QYS-JWT");
          Cookies.remove("ymuser");
          Cookies.remove("ymversion");
          this.$router.push({ path: "/" });
        },
      });
    },
    trimQuotes(str) {
      // 检查字符串首尾是否都为双引号
      if (str.length >= 2 && str[0] === '"' && str[str.length - 1] === '"') {
        return str.slice(1, -1); // 截取掉首尾引号
      }
      return str; // 否则返回原字符串
    },
    async editPhone() {
      if (!this.oldphone) return DonMessage.error(`请输入旧手机号`);
      if (!this.newphone) return DonMessage.error(`请输入新手机号`);
      const res = await this.$http.get(this.$urls.changephone, {
        oldphone: this.oldphone,
        newphone: this.newphone,
      });
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      DonMessage.success("修改成功");
      this.getUser();
      this.newphone = "";
      this.phonedialogimportVisible = false;
    },
    async editpsd() {
      if (!this.psd) return DonMessage.error(`请输入密码`);
      const res = await this.$http.get(this.$urls.changepassword, {
        oldpassword: this.password,
        newpassword: this.psd,
      });
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      DonMessage.success("修改成功，请重新登录");
      setTimeout(() => {
        Cookies.remove("QYS-JWT");
        Cookies.remove("ymuser");
        Cookies.remove("ymversion");
        this.$router.push({ path: "/" });
      }, 500);

      console.log("-user---", res);
    },
    openEdit() {
      this.editflg = true;
    },
    async getUser() {
      const res = await this.$http.get(this.$urls.loaduser);
      console.log("-user---", res);

      this.zhanghao = res.data.user.account;
      this.oldphone = res.data.user.phone;
      this.nickname = res.data.user.nickname;
      this.headimgurl = res.data.user.headimgurl;
      this.password = res.data.user.password;
    },
    async editUser() {
      if (!this.account) return DonMessage.error(`请输入账号`);
      if (!this.password) return DonMessage.error(`请输入密码`);

      const res = await this.$http.get(this.$urls.loaduser);
    },
  },
};
</script>

<style scoped lang="scss">
.import-mask {
  width: 100%;
  border-radius: 15px;
  background-image: url("../../assets/yimou/tb@2x.png");
  background-size: 100% 51px;
  background-repeat: no-repeat;
  padding-bottom: 40px;
  cursor: pointer;
  .import-mask-title {
    width: 100%;
    height: 51px;
    line-height: 51px;
    text-align: center;
    font-size: 18px;
    img {
      width: 13px;
      height: 13px;
      top: 21px;
      right: 20px;
    }
  }
  .mask_btn {
    width: 266px;
    height: 47px;
    background: #195cf8;
    border-radius: 10px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 17px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .mask_cont {
    margin-bottom: 20px;
    width: 350px;
    height: 54px;
    background: #f5f5f5;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    &.mar20 {
      margin-top: 20px;
    }
    .mask_cont_inp {
      text-align: right;
    }
    .mask_cont_right {
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
      .mask_cont_right_txt {
        font-family: PingFang SC;
        font-weight: bold;
        font-size: 18px;
        color: #195cf8;
        margin: 0 0 0 30px;
      }
    }
    .mask_cont_lebal {
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #232323;
    }
  }
  .mask_name {
    text-align: center;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #232323;
    margin: 20px 0;
  }
  .mask_head_box {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    margin: 30px;
    .mask_head {
      width: 109px;
      height: 109px;
      border-radius: 50%;
    }
    .mask_head_t {
      width: 63px;
      height: 26px;
      background: #195cf8;
      border-radius: 5px;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #ffffff;
      text-align: center;
      line-height: 26px;
      margin-top: -10px;
    }
  }

  .import-mask-but {
    width: 266px;
    height: 47px;
    line-height: 47px;
    text-align: center;
    background: rgba(25, 92, 248, 1);
    border-radius: 10px;
    font-size: 17px;
  }
}
.top_bar_item_lxbox {
  width: 455px;
  height: 258px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  background: url("../../assets/yimou/lxkfk@2x.png") no-repeat center center;
  .top_bar_item_lxbox_boxs {
    p {
      font-size: 18px;
      line-height: 18px;
    }
    div {
      width: 170px;
      height: 153px;
      background-image: url("../../assets/ym/ic_tc_sk.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-top: 22px;
      img {
        width: 160px;
        height: 143px;
      }
    }
  }
}
.edit_box {
  width: 307px;
  background: #f4f9ff;
  border-radius: 15px;

  padding: 0 11px;
  .edit_box_head {
    height: 82px;
    border-bottom: 1px solid #e8eff8;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .edit_head_box_r {
      width: 9px;
      height: 16px;
    }
    .edit_head_box {
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
      cursor: pointer;
      .edit_head_box_h {
        width: 55px;
        height: 55px;
        border-radius: 50%;
        margin-right: 10px;
      }
      .edit_head_box_t {
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #232323;
      }
    }
  }
  .edit_box_item {
    border-bottom: 1px solid #e8eff8;
    height: 57px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    .edit_box_item_lr {
      width: 9px;
      height: 16px;
    }
    .edit_box_item_l {
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
      .edit_box_item_licon {
        width: 15px;
        height: 20px;
        margin-right: 10px;
      }
      .edit_box_item_lt {
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #232323;
        &.red {
          color: #d83d39;
        }
      }
    }
  }
  .edit_box_banben {
    height: 52px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #232323;
    text-align: left;
    line-height: 52px;
  }
}
.top_bar {
  width: 100%;
  height: 72px;
  border-bottom: 1px solid #f5f5f5;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  padding: 0 25px;
  .top_bar_inp {
    width: 374px;
    height: 44px;
    background: #f3f3f3;
    border-radius: 22px;
    margin-right: 20px;
    padding: 0 15px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    .top_bar_inp_img1 {
      width: 35px;
      height: 35px;
      border-radius: 35px;
    }
    .top_bar_inp_inp {
      width: 230px;
      margin: 0 20px;
    }
    .top_bar_inp_lebal {
      width: 41px;
      height: 25px;
      background: #d83d39;
      border-radius: 5px;
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      line-height: 25px;
    }
  }
  .top_bar_item {
    margin: 0 20px 0 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .top_bar_item_img {
      width: 24px;
      height: 24px;
    }
    .top_bar_item_tit {
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 15px;
      color: #232323;
    }
  }
  .top_bar_head {
    width: 55px;
    height: 55px;
    cursor: pointer;
    border-radius: 50%;
  }
}
</style>
<style >
.el-popover {
  background: #f4f9ff !important;
  padding: 0;
}
.el-popover .popper__arrow::after {
  border-bottom-color: #f4f9ff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/headerboxs/index.vue